import { ProductShort } from '@models';

export class OfferProduct {
	id: number;
	offer_id: number;
	offer_package_id: number | null;
	product_id: string;
	discount: number;
	price_incl: number;
	price_excl: number;
	advice_price_incl: number;
	advice_price_excl: number;
	quantity: number;
	in_winebook: boolean;
	sort_order: number;
	created_at: string;
	updated_at: string;
	shop_product: ProductShort;

	constructor() {
		this.id = -1;
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/offer_product.ts